/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CorePayorReportBillingReportParams,
  CorePayorReportBillingReportDetailsParams,
  CorePayorReportSettlementStatementsParams,
  CorePayorReportFinancialAccountActivityParams,
  CorePayorReportRelationship1099IncomeParams,
  CorePayorReportInvoiceBatchReviewsParams,
  CorePayorReportGotpFeesParams,
  IntsRequest,
  UpdateQuickpaySettingsRequest,
  BillingReportResponse,
  CreditUsageResponse,
  SettlementStatementResponse,
  FinancialAccountActivityResponse,
  ListTermsResponse,
  ProfileSettingsResponse,
  ProfileSettingTypesResponse,
  UpdateQuickpaySettingsResult,
  Relationship1099Response,
  PayorInvoiceBatchReviewResponse,
  SuccessResponse,
  GotpFeeMonthsResponse
 } from '../types';

  //  CorePayorReportClient
class CorePayorReportClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly billingReport = (queryParams: CorePayorReportBillingReportParams): AxiosPromise<BillingReportResponse> => {
        let url_ = "/api/v1/core/payor/report/billing_activity";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly billingReportDetails = (queryParams: CorePayorReportBillingReportDetailsParams): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/billing_activity/details";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly creditUsage = (): AxiosPromise<CreditUsageResponse> => {
        let url_ = "/api/v1/core/payor/report/credit_usage";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly settlementStatements = (queryParams: CorePayorReportSettlementStatementsParams): AxiosPromise<SettlementStatementResponse> => {
        let url_ = "/api/v1/core/payor/report/settlement_statements";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly settlementStatement = (id: string | null): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/settlement_statement/{id}";
        if (id === undefined)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent(id !== null  ? "" + id : ""));

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getSettlementStatementSubscriptionInvoices = (id: string): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/settlement_statement/{id}/subscription_invoices";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getSettlementStatementRevenueShareInvoices = (id: string): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/settlement_statement/{id}/revenue_share_invoices";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getSettlementStatementLineItemReport = (id: string): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/settlement_statement/{id}/line_items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly financialAccountActivity = (id: number, queryParams: CorePayorReportFinancialAccountActivityParams): AxiosPromise<FinancialAccountActivityResponse> => {
        let url_ = "/api/v1/core/payor/report/financial_account_activity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly listTerms = (): AxiosPromise<ListTermsResponse> => {
        let url_ = "/api/v1/core/payor/report/terms";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly profileSettings = (payload: IntsRequest): AxiosPromise<ProfileSettingsResponse> => {
        let url_ = "/api/v1/core/payor/report/profile_settings";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly profileSettingTypes = (): AxiosPromise<ProfileSettingTypesResponse> => {
        let url_ = "/api/v1/core/payor/report/profile_setting_types";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateQuickpaySettings = (payload: UpdateQuickpaySettingsRequest): AxiosPromise<UpdateQuickpaySettingsResult> => {
        let url_ = "/api/v1/core/payor/report/quickpay_settings";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly relationship1099Income = (queryParams: CorePayorReportRelationship1099IncomeParams): AxiosPromise<Relationship1099Response> => {
        let url_ = "/api/v1/core/payor/report/relationship_1099";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly selectCarrierDiscovery = (): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/select_carrier_discovery";

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly invoiceBatchReviews = (queryParams: CorePayorReportInvoiceBatchReviewsParams): AxiosPromise<PayorInvoiceBatchReviewResponse> => {
        let url_ = "/api/v1/core/payor/report/invoice_batch_review";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly releaseInvoiceBatchReview = (id: string): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payor/report/invoice_batch_review/{id}/release";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly removeInvoiceBatchReview = (id: string): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payor/report/invoice_batch_review/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "DELETE",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getInvoiceBatchReviewReport = (id: string): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/invoice_batch_review/{id}/report";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly gotpFees = (queryParams: CorePayorReportGotpFeesParams): AxiosPromise<GotpFeeMonthsResponse> => {
        let url_ = "/api/v1/core/payor/report/gotp_fees";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly gotpFeesExportForMonth = (id: number | null): AxiosPromise<Blob> => {
        let url_ = "/api/v1/core/payor/report/gotp_fees/month/{id}";
        if (id === undefined)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent(id !== null  ? "" + id : ""));

        const sendRequestPayload: SendRequestPayload = {
            responseType: "blob",
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayorReportClient
  
export const corePayorReportClient = new CorePayorReportClient(baseClientConstructorProps);
